var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import createIconMenuAnimation from '../utils/gsapAnimations';
var MenuHamburgerIcon = function (_a) {
    var isOpen = _a.isOpen, _b = _a.customWidthHeight, customWidthHeight = _b === void 0 ? 'w-4' : _b, _c = _a.customColor, customColor = _c === void 0 ? 'text-enblue' : _c;
    var firstMainLinePathRef = useRef(null);
    var secondMainLinePathRef = useRef(null);
    var thirdLineHamburgerRef = useRef(null);
    var defaultTimeline = gsap.timeline();
    var _d = useState(defaultTimeline), iconMenuAnimation = _d[0], seticonMenuAnimation = _d[1];
    var _e = useState(false), isHamburgerTimelineReady = _e[0], setHamburgerReadyStatus = _e[1];
    useEffect(function () {
        if (!isHamburgerTimelineReady) {
            seticonMenuAnimation(createIconMenuAnimation({
                firstMainLinePathRef: firstMainLinePathRef,
                secondMainLinePathRef: secondMainLinePathRef,
                thirdLineHamburgerRef: thirdLineHamburgerRef,
            }));
            setHamburgerReadyStatus(true);
        }
        else {
            if (isOpen) {
                iconMenuAnimation.play();
            }
            else {
                iconMenuAnimation.reverse();
            }
        }
    }, [isOpen]);
    return (_jsxs("svg", __assign({ className: "stroke-current " + customWidthHeight + " " + customColor, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { ref: firstMainLinePathRef, stroke: "currentColor", strokeWidth: "2", d: "M2.5,5 C9.16667,5 15.83333,5 22.5,5 " }, void 0),
            _jsx("path", { ref: secondMainLinePathRef, stroke: "currentColor", strokeWidth: "2", d: "M2.5,12 C9.16667,12 15.83333,12 22.5,12 " }, void 0),
            _jsx("line", { ref: thirdLineHamburgerRef, x1: "2.5", y1: "19", x2: "15.5", y2: "19", strokeWidth: "2", stroke: "currentColor" }, void 0)] }), void 0));
};
export default MenuHamburgerIcon;
